import JobProcess from 'models/JobProcess';
import http from 'services/http';

export async function createAIArtifactExport(id: string) {
  return http.post<JobProcess>(`/ai_artifacts/${id}/exports`).then((res) => new JobProcess(res.data));
}
